export const FirearmPurposeConstants = {
    HUNTING_HANDGUN_OCCASIONAL_HUNTING: 'd675b6d1-58e5-4736-8c53-18e8cb1e4104',
    OCCASIONAL_SPORT_SHOOTING: '9a06fe86-ffed-41a1-b074-395b96c00d2b',
    PH_WORK: '6f0cd320-1c2c-44cb-ae8f-51e11293a94f',
    BUSINESS_PURPOSE: 'bfdc0be6-6646-4ae6-964d-53fc2d108400',
    COLLECTORS_LICENCE: '0da13d9b-97f8-4a97-a5ff-614ffee4e741',
    DEDICATED_SPORT_SHOOTING: '12b5999c-2f89-4d89-b77f-651426b761a3',
    HUNTING_HANDGUN_DEDICATED_HUNTING: 'ae76a497-aceb-4566-9073-70c44e8c21d7',
    COLLECTION: '5bf791ce-265e-4c69-bd3d-8253654c1db5',
    OCCASIONAL_HUNTING: '311f89ae-2634-4854-890b-8dbe0af32eb4',
    DEDICATED_HUNTING: '05900f06-ca53-4407-a1dd-97d1e7073029',
    BLACK_POWDER_NOT_COMPETENT: 'db88f77d-9546-418d-a649-9a9da751f8fa',
    CARRY_HANDGUN_OCCASIONAL_HUNTING: '19451268-23c6-4a2f-a2e7-aa6fdcaed0e0',
    SELF_PROTECTION: '2f02dc15-7075-4ce3-9c32-b546b496406d',
    SEMI_AUTO_RIFLE_DEDICATED_HUNTING_ON_GAME_FARM: 'bfb57669-0dbc-4d1c-8d2d-b847a774e1d7',
    CARRY_HANDGUN_DEDICATED_HUNTING: '4b1d2a15-ebf6-4d8c-ae83-d447f70b5acd',
    BLACK_POWDER_COMPETENT: '0bedd5f6-b400-4ea5-a7d6-d5d32c5dd853',
    ADDITIONAL_DUAL_LICENSE: '1c5955e3-1be3-4486-be72-d8f6bc56d725',
};
